// "Coming soon" holding mode for the public website.
//
// Turned on by setting REACT_APP_COMING_SOON=true on the frontend
// service. Create React App inlines env vars at BUILD time, so changing
// it needs a redeploy, not just a restart.
//
// What it covers
//   ON  → every customer-facing route renders <ComingSoon />: home, the
//         catalogue, cart, booking, track, reports, dashboard, tickets,
//         signup and all the content pages. Nobody can place an order.
//   OFF → the site behaves exactly as it does today. This is the
//         default, so nothing changes unless the variable is set.
//
// What it deliberately does NOT cover, and why
//   · /portal/* and /site-admin — the medical, lab, corporate, QA and
//     admin dashboards. These are staff tools; the lab keeps running
//     while the website is down.
//   · /login — PortalLayout sends staff here to sign in, so closing it
//     would lock them out of the portals above. Customers can still
//     reach it, but every page they could go on to is held, so there is
//     nothing to do once signed in.
//   · /app-privacy and /app — the privacy URL filed with the Play Store
//     and App Store, and the target of every printed QR code. Breaking
//     either can get the app listing flagged.
//   · The backend API and the admin panel are separate services and are
//     not touched by this at all. The mobile app keeps working.
const FLAG = String(process.env.REACT_APP_COMING_SOON || '').toLowerCase();

export const COMING_SOON = FLAG === 'true' || FLAG === '1';

// An optional escape hatch for checking the real site on the live URL.
// Visit /?preview=<token> once and this browser is exempt for the rest
// of the session. With no REACT_APP_PREVIEW_TOKEN set there is no token
// to guess, so the bypass does not exist.
const PREVIEW_TOKEN = process.env.REACT_APP_PREVIEW_TOKEN || '';
const PREVIEW_KEY = 'tl_preview';

// sessionStorage, not localStorage: a bypass should not outlive the
// browser tab. Wrapped because storage throws in a private window.
export const hasPreviewAccess = () => {
  if (!PREVIEW_TOKEN) return false;
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('preview');
    if (fromUrl && fromUrl === PREVIEW_TOKEN) {
      sessionStorage.setItem(PREVIEW_KEY, PREVIEW_TOKEN);
      return true;
    }
    return sessionStorage.getItem(PREVIEW_KEY) === PREVIEW_TOKEN;
  } catch {
    return false;
  }
};

// True when this visitor should see the holding page instead of the site.
export const shouldHoldSite = () => COMING_SOON && !hasPreviewAccess();
